
export const safeGtag: Gtag.Gtag = (c: any, t: any, d?: any) => {
    if (typeof gtag === "undefined") return;

    return gtag(c, t, d);
};